<div class="dp-wrapper">


    <form class="dp-hidden">
        <div class="input-group" class="dp-hidden">
            <input name="datepicker" class="dp-hidden" ngbDatepicker #datepicker="ngbDatepicker" [autoClose]="false"
                (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden"
                [startDate]="fromDate!" tabindex="-1" />
            <ng-template #t let-date let-focused="focused">
                <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                </span>
            </ng-template>
        </div>
        <!-- <div class="input-group">
            <input #dpFromDate class="form-control" placeholder="yyyy-mm-dd" name="dpFromDate"
                [value]="formatter.format(fromDate)" (input)="abcd(fromDate, dpFromDate.value)" />
            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datepicker.toggle()"
                type="button"></button>
        </div> -->
        <!-- <div class="col-12">
        <div class="input-group">
            <input #dpToDate class="form-control" placeholder="yyyy-mm-dd" name="dpToDate"
                [value]="formatter.format(toDate)" (input)="xyz(toDate, dpToDate.value)" />
            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datepicker.toggle()"
                type="button"></button>
        </div>
    </div> -->
    </form>
    <button class="btn btn-sm btn-info clear-dp" (click)="clearDp()">Clear</button>
</div>